import * as React from 'react';
import * as classNames from 'classnames';

interface IStarRatingProps {
  rating: number;
  count?: number;
  url?: string;
  largeStars?: boolean;

  // unfortunately sometimes our rating is 1-5 and other times it is from 0-1
  // this needs to be standardized
  ratingOutOf5?: boolean;
}

export default class StarRating extends React.Component<IStarRatingProps, any> {
  getRatingWidth() {
    const rating = this.props.ratingOutOf5 ? this.props.rating / 5 : this.props.rating;

    return {
      style: {
        width: `${rating * 100}%`,
      },
    };
  }

  render() {
    const classes = classNames(
      'star-rating',
      { 'star-rating--large': this.props.largeStars },
    );

    if (this.props.count === 0) return null;

    return (
      <div className={classes}>
        <div className="star-rating__stars">
          <div className="star-rating__stars__filled" {...this.getRatingWidth()} />
        </div>
        {this.props.count !== undefined &&
          <div className="star-rating__count">
            {Math.round(this.props.count).toLocaleString()}
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/star_rating.tsx